<template>
  <base-layout>
    <ul class="nav navbar-nav navbar-left" slot="toolbar_buttons">
      <li>
        <date-range-picker :dateFields="dateFields" :datesRange="datesRange" @dates-range-updated="updatedDates"></date-range-picker>
      </li>
      <li v-if="isAdmin">
        <button type="button" class="btn btn-icon" v-on:click="refreshDashboard" v-tooltip.bottom="'Refresh Dashboard'">
          <i class="fa fa-lg fa-refresh"></i>
        </button>
      </li>
      <li>
        <button class="btn btn-icon" v-bind:class="{filtered: showLeadsTable }"
          v-on:click="showLeadsTable = !showLeadsTable">
          <i class="fa fa-table"></i>
        </button>
      </li>
    </ul>
    <!-- slot main -->
    <div id="dashboard-canvas" class="col-xs-12 main with-leads-table" slot="main" v-bind:class="{ 'with-leads-table-active': showLeadsTable }">
      <!-- components -->
      <div class="row ls-charts">
        <div class="col-xs-12 spinner-container" v-if="isLoading">
          <i class="fa fa-circle-o-notch fa-spin fa-3x fa-fw" aria-hidden="true"></i>
        </div>
        <h1 v-if="dashboard.name">{{ dashboard.name }}</h1>
        <div class="col-xs-12 ls-charts-wrapper">
          <div class="grid-container">
            <!-- v-if="dashboard.active_components_count" -->
            <div class="grid" v-if="dashboard.components.length">
              <div class="col-xs-12">
		            <grid-layout
                  :layout="dashboard.components"
                  :col-num="6"
                  :row-height="60"
                  :vertical-compact="true"
                  :margin="[10, 10]"
                  :use-css-transforms="false"
                  :responsive="false"
                  :auto-size="true">
                  <!-- v-if="!item.draft" -->
                  <grid-item v-for="(item, index) in dashboard.components"
                    :static="true"
                    :key="item.id"
                    :x="item.x"
                    :y="item.y"
                    :w="item.w"
                    :h="item.h"
                    :i="item.id">
                    <component-box :width="item.w"
                      :height="item.h"
                      :component="item"
                      :index="index"
                      :datesRange="datesRange"
                      :isEditable="false">
                    </component-box>
                  </grid-item>
		            </grid-layout>
              </div>
            </div>
          </div>
	      </div>
      </div>
      <div v-if="showLeadsTable" class="row ls-leads-table">
        <div class="col-xs-12 leads-queue-wrapper">
          <div class="box panel leads-queue full-height">
            <div class="panel-content chart-wrapper full-height">
              <div class="endless-table-container full-height">
                <endless-table
                  :readOnly="true"
                  :pickedColumns="pickedColumns"
                  :isAdmin="isAdmin"
			            :datesRange="datesRange"
                  :showLeadsTable="showLeadsTable">
		            </endless-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </base-layout>
</template>

<script>
  import {BaseLayout} from 'components/layouts';
  import {LeadsModal} from 'components/modals/';

  import VueGridLayout from 'vue-grid-layout';

  var GridLayout = VueGridLayout.GridLayout
  var GridItem = VueGridLayout.GridItem

  import ComponentBox from 'components/elements/ComponentBox';
  import DateRangePicker from 'components/elements/DateRangePicker';
  import EndlessTable from 'components/elements/EndlessTable';

  export default {
    components: {
      BaseLayout,
      GridLayout,
      GridItem,
      ComponentBox,
      DateRangePicker,
      EndlessTable
    },
    data() {
         return {
           isAdmin: false,
           isLoading: false,
           datesRange: {
             from: null,
             to: null,
             date_field: null
           },
           showLeadsTable: false,
           dateFields: [],
           availableColumns: [],
           dashboard: {
	           name: null,
	           components: [],
	           cols: []
           }
         }
    },
    computed: {
      pickedColumns () {
        const columnsDb = this.availableColumns.reduce((acc, current) =>
          ({ ...acc, [current.id]: current }), {});
        return this.dashboard.cols.map((cid) => columnsDb[cid]);
      },
    },
    created () {
      var userData = this.$store.state.user;
      this.isAdmin = userData.role == "superuser";

      if (userData.current_account.account_type == 'vendor') {
        this.$router.push({name: 'vendors-stats'});
      }
      else {
        this.fetchDateFieldOptions();
        this.$set(this, 'datesRange', this.$store.getters.getDateRangeByField(null));
        this.fetchFields();
        this.fetchDashboard();
      }
    },
    methods: {
      async fetchFields() {
        let response = await API.fields.getList()
        this.availableColumns = response.data;
      },
      async fetchDateFieldOptions() {
        let dateFields = await API.dateFields.getList();
        this.dateFields = [{id: '', value: '', label: 'default', name: 'default'}]
          .concat(dateFields.data.map( (x) => { return { id: x.id, value: x.id, label: x.name, name: x.name} }));
      },
      async fetchDashboard() {
        if (!this.isLoading) {
          this.isLoading = true;
          let data = await this.fetchData();
          this.$set(this, 'dashboard', data);
          this.isLoading = false;
        }
      },
      updatedDates(datesRange) {
        let changed = !_.isEqual(this.datesRange, datesRange);
        if (changed) {
          this.$set(this, 'datesRange', datesRange);
          this.refreshDashboard();
        }
      },
      prepareRequest() {
        let params = {};
        for (const [key, value] of Object.entries(this.datesRange)) {
          if (value) {
            params[key] = value;
          }
        }
        return params;
      },
      async refreshDashboard() {
        let data = await this.fetchData();
        this.$set(this.dashboard, 'components', data.components);
      },
      async fetchData() {
        let params = this.prepareRequest();
        let apiResponse = await API.dashboards.getDefaultDashboard('home', params);
        return apiResponse.data;
      },
      toggleLeadsTable() {
        this.showLeadsTable = false;
      },
    }
 }
</script>



// WEBPACK FOOTER //
// Home.vue?fd43ef66